// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".close-button[data-v-2c2a7c29]{position:absolute;top:4px;right:4px;background:transparent;border:none;color:#fff;font-size:16px;cursor:pointer;transition:.4s}.close-button[data-v-2c2a7c29]:hover{transform:rotate(180deg)}.mancontent[data-v-2c2a7c29]{position:relative;left:-10px;margin-left:10px;cursor:pointer}.mancontent:hover .linkedit[data-v-2c2a7c29]{color:#b4b4b4;text-decoration:underline}", ""]);
// Exports
module.exports = exports;
